"use client";
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubscriptionModal from './cms/SubscriptionModal';
import { supabase } from '../lib/supabaseClient';

const TopNav = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [subscriptionPlan, setSubscriptionPlan] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) {
        console.error('Error fetching session:', error);
        return;
      }
      if (session && session.user) {
        setUser(session.user);
        const { data, error: profileError } = await supabase
          .from('profiles')
          .select('plan')
          .eq('user_id', session.user.id)
          .single();
        if (profileError) {
          console.error('Error fetching subscription plan:', profileError);
        } else {
          setSubscriptionPlan(data.plan);
        }
      }
    };

    fetchUser();
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="py-2 shadow-md bg-gray-950 h-12 min-h-12 text-white">
        <div className="flex justify-end items-center gap-4 pr-4">
          {!user ? (
            <Link to="/login" className="bg-blue-500 px-2 py-1 rounded shadow-sm shadow-primary">Log In</Link>
          ) : (
            subscriptionPlan !== 'pro' && (
              <button onClick={handleOpenModal} className="nn-gradient px-2 py-1 rounded shadow-sm shadow-primary">
                {subscriptionPlan === 'free' ? 'Create an Account' : 'Upgrade Account'}
              </button>
            )
          )}
        </div>
      </div>
      <SubscriptionModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default TopNav;